
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1308_3832)","fill":"#646E87"}},[_c('path',{attrs:{"d":"M7 1.167a5.852 5.852 0 014.155 1.75H9.332a.583.583 0 000 1.166h2.417A1.084 1.084 0 0012.833 3V.583a.583.583 0 10-1.166 0v1.212A6.99 6.99 0 00.029 6.358.587.587 0 001 6.856a.573.573 0 00.19-.368A5.842 5.842 0 017 1.167zM13.388 7a.573.573 0 00-.577.512 5.825 5.825 0 01-9.966 3.571h1.822a.583.583 0 000-1.166H2.25A1.083 1.083 0 001.167 11v2.417a.583.583 0 101.166 0v-1.213a6.989 6.989 0 0011.638-4.562.586.586 0 00-.583-.642z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1308_3832"}},[_c('rect',{attrs:{"width":"14","height":"14","fill":"#fff"}})])])])
          )
        }
      }
    